module.exports = __webpack_public_path__ + "static/media/t4.317178a2.png";